var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.811,
    height: 10.121
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11011",
    d: "m1.061 9.061 4-4-4-4",
    fill: "none",
    stroke: "#1c3d53",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
};
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1LjgxMSIgaGVpZ2h0PSIxMC4xMjEiIHZpZXdCb3g9IjAgMCA1LjgxMSAxMC4xMjEiPgogIDxwYXRoIGlkPSJQYXRoXzExMDExIiBkYXRhLW5hbWU9IlBhdGggMTEwMTEiIGQ9Ik0yMzQsMjQwbDQtNC00LTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMzIuOTM5IC0yMzAuOTM5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMWMzZDUzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo=";